import { render, staticRenderFns } from "./UniseriateForm.vue?vue&type=template&id=317b9aa2&scoped=true"
import script from "./UniseriateForm.vue?vue&type=script&lang=js"
export * from "./UniseriateForm.vue?vue&type=script&lang=js"
import style0 from "./UniseriateForm.vue?vue&type=style&index=0&id=317b9aa2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317b9aa2",
  null
  
)

export default component.exports